export default "__VITE_ASSET__BbrEVisU__"